export default __webpack_public_path__ + "static/media/Avatar-26.b6c128ae.png";